// extracted by mini-css-extract-plugin
export default {"gdpr-content-wrapper":"GDPR_gdpr-content-wrapper__+D+mC"};